module.exports = __webpack_public_path__ + "static/Flixbus-e5ef7b4271c2ff515fb6aec9dd5ef201.webp";